// Select the elements
const navMainToggle = document.querySelector('.nav-main-toggle');
const navMain = document.querySelector('.nav-main');

// Add event listener to the navMainToggle
navMainToggle.addEventListener('click', () => {
  // Toggle the class 'open' on navMain
  navMain.classList.toggle('open');
});


const cursor = document.querySelector('.mousy');

let mouseX = 0;
let mouseY = 0;

let cursorX = 0;
let cursorY = 0;

let speed = 0.5; // change to increase the ease

function animate() {
let distX = mouseX - cursorX;
let distY = mouseY - cursorY;

cursorX = cursorX + distX * speed;
cursorY = cursorY + distY * speed;

cursor.style.left = cursorX + 'px';
cursor.style.top = cursorY + 'px';

requestAnimationFrame(animate);
}

animate();

document.addEventListener('mousemove', (event) => {
mouseX = event.pageX;
mouseY = event.pageY;

  if (document.querySelector('body .nav-main__menu__item:hover') != null) {
     cursor.classList.add('mousy--logo');
  } else {
     cursor.classList.remove('mousy--logo');
  }
  if (document.querySelector('body .nav-main a:hover') != null) {
      cursor.classList.remove('mousy--logo');
  }
});
